import { motion } from "framer-motion";


const NavButton = ({
  icon,
  label,
  danger = false,
  isExpanded = false,
  isActive = false,
  onClick,
}: {
  icon: React.ReactNode;
  label: string;
  danger?: boolean;
  isExpanded?: boolean;
  isActive?: boolean;
  onClick?: () => void;
}) => {
  return (
    <motion.button
      onClick={onClick}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className={`group flex items-center p-1.5 w-full h-12 text-sm font-medium rounded-xl transition-all duration-300 relative overflow-hidden ${
        danger
          ? "bg-gradient-to-r from-red-600/20 to-red-700/20 hover:from-red-600/30 hover:to-red-700/30 border border-red-500/30 hover:border-red-500/50 shadow-sm hover:shadow-md"
          : isActive
            ? "bg-gradient-to-r from-red-600/20 to-red-700/20 border border-red-500/30 shadow-md"
            : "hover:bg-gradient-to-b hover:from-gray-800/60 hover:to-gray-900/60 border border-transparent hover:border-gray-700/50 hover:shadow-md"
      }`}
    >
      {/* Decorative elements */}
      <div
        className={`absolute inset-0 bg-gradient-to-r from-red-600/5 via-red-600/5 to-transparent opacity-0 group-hover:opacity-50 transition-opacity duration-300 ${isActive ? "opacity-50" : ""}`}
      ></div>

      {/* Icon container with gradient background */}
      <div
        className={`relative z-10 flex items-center justify-center min-w-[32px] h-8 rounded-lg transition-all duration-300 ${
          danger
            ? "bg-gradient-to-br from-red-500/30 to-red-700/30 text-red-400 group-hover:from-red-500/40 group-hover:to-red-700/40"
            : isActive
              ? "bg-gradient-to-br from-red-500/20 to-red-700/20 text-red-400 border border-red-500/10"
              : "bg-gradient-to-br from-gray-700/50 to-gray-800/50 text-gray-400 group-hover:from-red-500/20 group-hover:to-red-700/20 group-hover:text-red-400 border border-gray-700/30 group-hover:border-red-500/10"
        }`}
      >
        {icon}
      </div>

      {/* Label with gradient text */}
      {isExpanded && (
        <motion.span
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -10 }}
          transition={{ duration: 0.3 }}
          className={`ml-3 relative z-10 ${
            danger
              ? "text-red-400 group-hover:text-red-300"
              : isActive
                ? "bg-gradient-to-r from-white to-red-300 bg-clip-text text-transparent"
                : "text-gray-300 group-hover:bg-gradient-to-r group-hover:from-white group-hover:to-red-300 group-hover:bg-clip-text group-hover:text-transparent"
          }`}
        >
          {label}
        </motion.span>
      )}
    </motion.button>
  );
};

export default NavButton;
